import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { type SignupOrigin, useSignupClick } from '@/provider/useSignupClick'

interface GatedNavItemProps {
  label: string
  tooltip: string
  /** Where this gated upsell sits, for signup_clicked attribution. */
  origin: SignupOrigin
}

// History/Schedules are logged-in features. On the anonymous free tool they
// appear muted as upsell bait: a tooltip explains the gate; clicking sends the
// user to VWAM signup (the conversion door). No lock icon, by design.
export function GatedNavItem({ label, tooltip, origin }: GatedNavItemProps) {
  const { signupUrl, onSignupClick } = useSignupClick()

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={signupUrl}
            onClick={() => onSignupClick(origin)}
            className="text-sm text-muted-foreground hover:text-foreground px-2 cursor-pointer"
          >
            {label}
          </a>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
